var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreaseBookings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23626_18126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 5.5C15.1529 5.5 15.6192 5.69315 15.963 6.03697C16.3068 6.38079 16.5 6.8471 16.5 7.33333V9.16667H27.5V7.33333C27.5 6.8471 27.6932 6.38079 28.037 6.03697C28.3808 5.69315 28.8471 5.5 29.3333 5.5C29.8196 5.5 30.2859 5.69315 30.6297 6.03697C30.9735 6.38079 31.1667 6.8471 31.1667 7.33333V9.16667H34.8333C35.8058 9.16667 36.7384 9.55298 37.4261 10.2406C38.1137 10.9282 38.5 11.8609 38.5 12.8333V34.8333C38.5 35.8058 38.1137 36.7384 37.4261 37.4261C36.7384 38.1137 35.8058 38.5 34.8333 38.5H9.16667C8.19421 38.5 7.26157 38.1137 6.57394 37.4261C5.88631 36.7384 5.5 35.8058 5.5 34.8333V12.8333C5.5 11.8609 5.88631 10.9282 6.57394 10.2406C7.26157 9.55298 8.19421 9.16667 9.16667 9.16667H12.8333V7.33333C12.8333 6.8471 13.0265 6.38079 13.3703 6.03697C13.7141 5.69315 14.1804 5.5 14.6667 5.5ZM21.8918 18.5918C18.8888 15.554 14.5768 18.3645 14.6685 22.506C14.7235 24.9993 16.676 27.39 20.526 29.6762L20.6232 29.7348C21.076 30.0043 21.659 30.3508 22 30.3508C22.341 30.3508 22.924 30.0043 23.375 29.7348L23.474 29.6762C27.324 27.39 29.2765 24.9993 29.3315 22.506C29.4232 18.3627 25.1112 15.554 22.1082 18.5918C22.0797 18.6202 22.0411 18.6361 22.0009 18.6361C21.9607 18.6361 21.9222 18.6202 21.8937 18.5918",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23626_18126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseBookings);
export default __webpack_public_path__ + "static/media/increase-bookings.ccea3ae9a47ac1c9f8d3ef2896fe5845.svg";
export { ForwardRef as ReactComponent };